<h1 mat-dialog-title>Setting</h1>

<div mat-dialog-content>
    <mat-form-field class="w-100">
        <mat-label>{{data.settingKey}}</mat-label>
        <input matInput [(ngModel)]="data.settingValue">
    </mat-form-field>
</div>

<div mat-dialog-actions class="ml-auto">
    <button mat-raised-button class="mat-error" (click)="onCancelClick()">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
</div>